// Styles
import './featured-collection.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFeaturedCollection = (context) => {
  const carousel_banner = context.closest('.shopify-section');

  if (carousel_banner) {
    const slider = carousel_banner.querySelector('.carousel-container');
    const arrow_right = carousel_banner.querySelector('.featured-collection__arrow__right');
    const arrow_left = carousel_banner.querySelector('.featured-collection__arrow__left');
    var slide_width = carousel_banner.querySelector('.featured-collection__block').clientWidth;
    var active_slide = carousel_banner.querySelector('[active-slide]');
    var active_slide_index = parseInt(active_slide.getAttribute('slide-index'));
    var max_scroll = slider.scrollWidth - (slide_width * 2);
    var min_scroll = 0;
    var isDown = false;
    var startX;
    if(window.innerWidth >= 768) {
      max_scroll = slider.scrollWidth - (slide_width * 3);
    }

    arrow_right.addEventListener('click', () => {
      slider.scrollLeft = (active_slide_index + 1) * slide_width;
    });

    arrow_left.addEventListener('click', () => {
      slider.scrollLeft = (active_slide_index - 1) * slide_width;
    });

    slider.addEventListener('scroll', () => {
      carousel_banner.querySelectorAll('.featured-collection__block').forEach(el => {
        el.removeAttribute('active-slide');
        const index = parseInt(el.getAttribute('slide-index'));
        if(slider.scrollLeft >= (index * slide_width) && slider.scrollLeft < ((index + 1) * slide_width)) {
          el.setAttribute('active-slide', '');
          active_slide_index = index;
        }
      });

      if(slider.scrollLeft < max_scroll) {
        window.dAgency.showArrow(arrow_right);
      } else {
        window.dAgency.hideArrow(arrow_right);
      }
      if(slider.scrollLeft > min_scroll) {
        window.dAgency.showArrow(arrow_left);
      } else {
        window.dAgency.hideArrow(arrow_left);
      }
    });
  }
}

window.dAgency.showArrow = (element) => {
  element.style.opacity = 1;
  element.style.cursor = 'pointer';
  element.style.pointerEvents = 'all';
}

window.dAgency.hideArrow = (element) => {
  element.style.opacity = 0;
  element.style.cursor = 'initial';
  element.style.pointerEvents = 'none';
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.featured-collection__blocks-container.carousel-container'), (el) => {
    window.dAgency.initFeaturedCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.featured-collection__blocks-container.carousel-container'), (el) => {
      window.dAgency.initFeaturedCollection(el);
    });
  });
}
